import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Box,
  Grid,
  TextField,
  Tooltip
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CommonUtil from "../../Util/CommonUtils";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";

export default function DealerFilter(props) {
  const [open, setOpen] = React.useState(props.open);
  const { t } = useTranslation();
  const [statusValue, SetstatusValue] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const status = [
    { label: t("STATUS_ACTIVE") },
    { label: t("STATUS_IN_ACTIVE") },
  ];

  const [payload, setPayload] = useState({
    name: "",
    status: "",
    email: "",
  });

  const handleClose = () => {
    setPayload({
      name: "",
      status: "",
      email: "",
    });
    setOpen(false);
  };

  const [error, setError] = useState({
    name: false,
    status: false,
    email: false,
  });

  const reset = () => {
    if (
      payload.name.trim() === "" &&
      payload.status.trim() === "" &&
      payload.email.trim() === ""
    ) {
      Toast(t("Nothing to Reset"), "error");
      return;
    }

    setPayload({
      name: false,
      status: false,
      email: false,
    });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handleSubmit = () => {
    if (
      payload.name.trim() === "" &&
      payload.status.trim() === "" &&
      payload.email.trim() === ""
    ) {
      Toast(t("FILTERISEMPTY"), "error");
      return;
    }
    props.applyFilter(payload);
    setPayload({
      name: "",
      status: "",
      email: "",
    });
    handleClose();
  };

  const handleChangeLangauage = (data) => {
    let status = "";
    switch (data) {
      case t("STATUS_ACTIVE"):
        status = "ACTIVE";
        break;
      case t("STATUS_IN_ACTIVE"):
        status = "INACTIVE";
        break;
      default:
        status = "";
    }
    SetstatusValue(status);
    return status;
  };

  useEffect(() => { }, []);

  return (
    <>
      <Tooltip title={t("COMMON006")}>
        <Box
          item
          className={"filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover style={{ color: "#474a4e" }} />
          ) : (
            <FilterIcon style={{ color: "#474a4e" }} />
          )}
        </Box>
      </Tooltip>

      <DialogBox
        Header={t("FILTER")}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          justifyContent="center"
          style={{ width: "100%" }}
        >
          <Grid item xs={12} sm={12}>
            <CustomTextfield
              label={t("FILTERDEALERNAME")}
              error={error.name}
              name="name"
              value={payload.name}
              handleChange={(e) => handleChange(e)}
              helperText={error.name}
              autoComplete="on"
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              options={status}
              renderInput={(params) => (
                <TextField {...params} label={t("CUSTDATABLE07")} />
              )}
              sx={{
                width: "100%",
              }}
              onChange={(event, value) => {
                if (!CommonUtil.isEmpty(value)) {
                  const selectedStatus = handleChangeLangauage(value.label);
                  setPayload({
                    ...payload,
                    status: selectedStatus,
                  });
                } else {
                  setPayload({
                    ...payload,
                    status: "",
                  });
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <CustomTextfield
              label={t("CUSTDATABLE02")}
              error={error.email}
              name="email"
              value={payload.email}
              handleChange={(e) => handleChange(e)}
              helperText={error.email}
              autoComplete="on"
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
